// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_39jvFeFvHPd6DO7pZuMFc8_0","no-data":"_2P7NaYk3XIXXtQrc36pfPH_0","collapse-item-hide":"_3qNuNvjM0QsLHArinN3HIR_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2552435a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dashboard/components/frame/DashboardWidgetSettingSide.vue
// module id = crHO
// module chunks = 75